<!-- Start Page Header -->
<div class="page-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">

                <h2 class="entry-title">
                    {{ 'articles' | translate }}
                </h2>

                <div class="breadcrumb">

                    <span>
                        {{ 'here' | translate }} :
                    </span>

                    <a routerLink="/Home">
                        {{ 'home' | translate }}
                    </a>

                    <span class="crumbs-spacer">
                        <i class="fa fa-angle-double-right"></i>
                    </span>

                    <span class="current">
                        {{ 'articles' | translate }}
                    </span>

                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Header -->


<!-- Start Articles Section -->
<section id="content" class="articles-section">
    <div class="container">

        <div class="articles-heading">
            <h2 class="big-title">
                {{ 'latestArticles' | translate }}
            </h2>

            <p>
                {{ 'articlesDescription' | translate }}
            </p>
        </div>


        <!-- Loading -->
        <div class="articles-state" *ngIf="isLoading">

            <i class="fa fa-spinner fa-spin"></i>

            <p>
                {{ 'loadingArticles' | translate }}
            </p>

        </div>


        <!-- Error -->
        <div class="articles-error" *ngIf="!isLoading && errorMessage">

            <i class="fa fa-exclamation-circle"></i>

            <h3>
                {{ 'articlesLoadingError' | translate }}
            </h3>

            <p>
                {{ errorMessage }}
            </p>

            <button type="button" class="btn btn-effect" (click)="loadArticles()">

                <i class="fa fa-refresh"></i>

                {{ 'tryAgain' | translate }}

            </button>

        </div>


        <!-- Empty -->
        <div class="articles-state" *ngIf="
                !isLoading &&
                !errorMessage &&
                articles.length === 0
            ">

            <i class="fa fa-newspaper-o"></i>

            <h3>
                {{ 'noArticles' | translate }}
            </h3>

            <p>
                {{ 'noArticlesDescription' | translate }}
            </p>

        </div>


        <!-- Articles Cards -->
        <div class="row article-list" *ngIf="
                !isLoading &&
                !errorMessage &&
                articles.length > 0
            ">

            <div class="col-lg-4 col-md-6 col-sm-12 article-column" *ngFor="
                    let article of articles;
                    trackBy: trackByArticle
                ">

                <article class="article-card">

                    <!-- Image -->
                    <a class="article-image" [routerLink]="[
                            '/Articles',
                            getArticleSlug(article)
                        ]">

                        <img [src]="getArticleImage(article)" [alt]="getArticleTitle(article)"
                            (error)="handleImageError($event)" />

                        <div class="article-image-overlay">
                            <i class="fa fa-link"></i>
                        </div>

                    </a>


                    <!-- Content -->
                    <div class="article-card-content">

                        <div class="article-meta">

                            <span class="article-date" *ngIf="article.publishedDate">

                                <i class="fa fa-calendar"></i>

                                {{
                                article.publishedDate
                                | date:'dd MMMM yyyy'
                                }}

                            </span>

                            <span class="article-author" *ngIf="article.author">

                                <i class="fa fa-user"></i>

                                {{ article.author }}

                            </span>

                        </div>


                        <h3 class="article-title">

                            <a [routerLink]="[
                                    '/Articles',
                                    getArticleSlug(article)
                                ]">

                                {{ getArticleTitle(article) }}

                            </a>

                        </h3>


                        <p class="article-summary" *ngIf="getArticleSummary(article)">

                            {{ getArticleSummary(article) }}

                        </p>


                        <a class="article-read-more" [routerLink]="[
                                '/Articles',
                                getArticleSlug(article)
                            ]">

                            <span>
                                {{ 'readMore' | translate }}
                            </span>

                            <i class="fa" [ngClass]="
                                    currentLang === 'ar'
                                        ? 'fa-angle-double-left'
                                        : 'fa-angle-double-right'
                                ">
                            </i>

                        </a>

                    </div>

                </article>

            </div>

        </div>

        <!-- Pagination -->
        <nav class="articles-pagination" *ngIf="
        !isLoading &&
        !errorMessage &&
        articles.length > 0 &&
        totalPages > 1
    " [attr.aria-label]="'articlesPagination' | translate">

            <!-- Previous -->
            <button type="button" class="pagination-button pagination-direction" [disabled]="
            !hasPrevious ||
            isLoading
        " (click)="previousPage()">

                <i class="fa" [ngClass]="
                currentLang === 'ar'
                    ? 'fa-angle-double-right'
                    : 'fa-angle-double-left'
            ">
                </i>

                <span>
                    {{ 'previous' | translate }}
                </span>

            </button>

            <!-- First Page -->
            <button type="button" class="pagination-button" *ngIf="visiblePages[0] > 1" [class.active]="page === 1"
                [attr.aria-current]="
            page === 1
                ? 'page'
                : null
        " (click)="goToPage(1)">

                1

            </button>

            <!-- Beginning Dots -->
            <span class="pagination-dots" *ngIf="visiblePages[0] > 2">

                ...

            </span>

            <!-- Visible Pages -->
            <button type="button" class="pagination-button" *ngFor="
            let pageNumber of visiblePages;
            trackBy: trackByPage
        " [class.active]="
            page === pageNumber
        " [attr.aria-current]="
            page === pageNumber
                ? 'page'
                : null
        " (click)="goToPage(pageNumber)">

                {{ pageNumber }}

            </button>

            <!-- Ending Dots -->
            <span class="pagination-dots" *ngIf="
            visiblePages[
                visiblePages.length - 1
            ] < totalPages - 1
        ">

                ...

            </span>

            <!-- Last Page -->
            <button type="button" class="pagination-button" *ngIf="
            visiblePages[
                visiblePages.length - 1
            ] < totalPages
        " [class.active]="
            page === totalPages
        " [attr.aria-current]="
            page === totalPages
                ? 'page'
                : null
        " (click)="goToPage(totalPages)">

                {{ totalPages }}

            </button>

            <!-- Next -->
            <button type="button" class="pagination-button pagination-direction" [disabled]="
            !hasNext ||
            isLoading
        " (click)="nextPage()">

                <span>
                    {{ 'next' | translate }}
                </span>

                <i class="fa" [ngClass]="
                currentLang === 'ar'
                    ? 'fa-angle-double-left'
                    : 'fa-angle-double-right'
            ">
                </i>

            </button>

        </nav>

    </div>
</section>
<!-- End Articles Section -->